/**
 * PayrollTrendChart — 12 havi bérszámfejtési trend vonal-diagram
 * Recharts LineChart: totalGross / totalNet / totalEmployerCost
 */

import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import type { PayrollRunDto } from '../api/payroll-api';

interface Props {
  runs: PayrollRunDto[];
}

interface ChartRow {
  period: string;
  totalGross: number;
  totalNet: number;
  totalEmployerCost: number;
}

function formatFt(value: number): string {
  return `${value.toLocaleString('hu-HU')} Ft`;
}

export function PayrollTrendChart({ runs }: Props) {
  if (runs.length === 0) {
    return <p className="text-muted-foreground text-sm text-center py-8">Nincs adat a trendhez</p>;
  }

  const data: ChartRow[] = [...runs]
    .sort((a, b) => a.year - b.year || a.month - b.month)
    .map(r => ({
      period: `${r.year}.${String(r.month).padStart(2, '0')}`,
      totalGross: r.totalGross,
      totalNet: r.totalNet,
      totalEmployerCost: r.totalEmployerCost,
    }));

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data} margin={{ top: 4, right: 16, left: 16, bottom: 4 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="period" tick={{ fontSize: 12 }} />
        <YAxis tickFormatter={(v: number) => v.toLocaleString('hu-HU')} tick={{ fontSize: 11 }} />
        <Tooltip formatter={(value: number) => formatFt(value)} />
        <Legend />
        <Line
          type="monotone"
          dataKey="totalGross"
          name="Bruttó"
          stroke="#2563eb"
          strokeWidth={2}
          dot={false}
        />
        <Line
          type="monotone"
          dataKey="totalNet"
          name="Nettó"
          stroke="#16a34a"
          strokeWidth={2}
          dot={false}
        />
        <Line
          type="monotone"
          dataKey="totalEmployerCost"
          name="Munkáltatói teher"
          stroke="#dc2626"
          strokeWidth={2}
          dot={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
